import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import { Panel, PanelGroup } from 'react-bootstrap';
import get from 'lodash/get';
import findLastIndex from 'lodash/findLastIndex';
import sortBy from 'lodash/sortBy';
import { arrayMove } from 'react-sortable-hoc';
import Button from 'react-bootstrap-button-loader';
import { setLoader, removeLoader } from '../../../../actions';
import { SspApi } from '../../../../api';
import { categories } from '../../../../utils/constants';
import ResultList from './ResultList';
import FilterList from './FilterList';

import {
  InputField,
  FontField,
  SliderField,
  SelectField,
  ColorField,
  required
} from '../../../../components/form';

class Feed extends Component {

  state = { slots: [], filters: [] };

  componentDidMount() {
    this.fetchSlots();
    this.fetchFilters();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.website.uuid !== this.props.website.uuid) {
      this.fetchSlots();
      this.fetchFilters();
    }
  }

  onFormSubmit(vals) {
    const {
      dispatch,
      website,
      websites
    } = this.props;

    const filters = this.state.filters.map((f) => {
      return { ssp_filter_id: f.id, position: this.state.filters.indexOf(f) };
    });

    const ad_slots = this.state.slots.filter((s) => s.type === 'ad').map((s) => {
      return { ad_slot_id: s.id, position: this.state.slots.indexOf(s) };
    });

    const values = { ...vals, filters, ad_slots };

    dispatch(setLoader('FeedSettingsForm'));
    dispatch(SspApi.actions.websiteUpdate.post(website.uuid, values, (error, success) => {
      dispatch(removeLoader('FeedSettingsForm'));
      if (success) {
        const collection = [...websites.data].map((obj) => {
          return obj.uuid === success.data.uuid ? success.data : obj;
        });

        if (success.data.uuid) {
          dispatch(SspApi.actions.pixel.get({ ssp_website_id: website.uuid }));
        }

        dispatch({
          type: SspApi.events.websites.actionSuccess,
          syncing: false,
          data: { ...websites, data: collection, meta: { ...websites.meta } }
        });
      }
    }));
  }

  onSortEnd({ oldIndex, newIndex }) {
    this.setState({ slots: arrayMove([...this.state.slots], oldIndex, newIndex) });  
  }

  onFilterSortEnd({ oldIndex, newIndex }) {
    this.setState({ filters: arrayMove([...this.state.filters], oldIndex, newIndex) });  
  }

  fetchSlots(params = {}) {
    const { website, dispatch } = this.props;
    if (website.uuid) {
      const data = { ...params, ssp_website_id: website.uuid };
      dispatch(SspApi.actions.adSlotsVirtual.get(data, (error, success) => {
        if (success) {
          const n = (website.feed_jobs_per_page || 0) + success.data.length;
          const feedSlots = [...Array(n).keys()].map(() => {
            return { type: 'feed' };
          });

          (success.data || []).forEach((e) => {
            const sl = { ...e, type: 'ad' };
            feedSlots[e.position] = sl;
          });

          this.setState({ slots: feedSlots, adSlots: success.data });
        }
      }));  
    }
  }


  fetchFilters(params = {}) {
    const { website, dispatch } = this.props;
    if (website.uuid) {
      const data = { ...params, ssp_website_id: website.uuid };
      dispatch(SspApi.actions.filtersVirtual.get(data, (error, success) => {
        if (success) {
          this.setState({ filters: sortBy((success.data || []), (o) => o.position) });
        }
      }));  
    }
  }

  updateSlots(jp) {
    const { slots, adSlots } = this.state;
    const v = window.parseInt(jp.value) + adSlots.length;
   
    const feedSlots = [...Array(v).keys()].map(() => {
      return { type: 'feed' };
    });

    slots.filter((e) => e.type === 'ad').forEach((e) => {
      const idx = slots.indexOf(e);
      if (feedSlots[idx] === undefined) {
        const rdx = findLastIndex(feedSlots, (o) => o.type === 'feed');
        feedSlots.splice(rdx, 1);
        feedSlots.push(e);
      } else {
        feedSlots[idx] = e;
      }
    });
    this.setState({ slots: feedSlots });
  }

  render() {
    const { handleSubmit, isLoading, selectedOptions } = this.props;

    const major = Object.keys(categories).map(c => ({ label: c, value: c }));
    const minor = selectedOptions.feed_category ? 
      categories[selectedOptions.feed_category].map(c => ({ label: c, value: c })) : [];

    return (
      <form 
        onSubmit={handleSubmit(this.onFormSubmit.bind(this))} 
        className='m-t'
      >
        <br />
        <h5 style={{ fontSize: 14, fontWeight: 700 }}>Feed Settings</h5> 

        <div className='ibox'>
          <div className='ibox-content'>
            <Field
              type='number'
              name='website[feed_min_cpc]'
              placeholder='Minimum cpc for the feeds'
              label='Feed Min CPC'
              component={InputField}
              validate={[required]}
            />
            <Field
              type='number'
              name='website[feed_jobs_per_page]'
              placeholder='Number of search results per page'
              label='Results Per Page'
              component={SelectField}
              validate={[required]}
              options={[
                { label: 10, value: 10 },
                { label: 15, value: 15 },
                { label: 20, value: 20 }
              ]}
              normalize={(e) => (e ? e.value : 10)}
              onChange={this.updateSlots.bind(this)}
            />

            <Field 
              type='text' 
              name='website[feed_category]' 
              placeholder='Please select a category'
              label='Category' 
              component={SelectField}
              options={major}
              normalize={(e) => (e ? e.value : '')}
              value={null}
              onChange={() => this.props.change('website[feed_sub_category]', [])}
            />
            <small>
              <strong>
                Leave the category blank to make all categories searchable.
              </strong>
            </small>

            <br /><br />
            { 
              selectedOptions.feed_category ?
                <div >
                  <Field 
                    type='text' 
                    name='website[feed_sub_category]' 
                    placeholder='Please select a sub categories'
                    label='Sub Category' 
                    component={SelectField}
                    multiple
                    value={[]}
                    options={minor}
                    normalize={(e) => e.map(s => s.value)}
                  />
                  <small>
                    <strong>
                      Leave the sub category blank to make all sub 
                      categories searchable for the selected category.
                    </strong>
                  </small>
                  <br /><br />
                </div> : null
            }
          </div>
        </div>
        
        <br />
        <h5 style={{ fontSize: 14, fontWeight: 700 }}>Style Settings</h5> 

        <div className='ibox'>
          <div className='ibox-content'>
            <br />
            <PanelGroup accordion id="accordion-style-settings" defaultActiveKey="1">
              
              <Panel eventKey="1">
                <Panel.Heading>
                  <Panel.Title toggle>Container</Panel.Title>
                </Panel.Heading>
                <Panel.Body collapsible>
                  <Field 
                    name='website[feed_style][container][backgroundColor]'
                    label='Background Color'
                    component={ColorField}
                    hex
                  />

                  <Field 
                    type='text' 
                    name='website[feed_style][container][fontFamily]' 
                    placeholder='Font Family'
                    label='Font Family' 
                    component={FontField}
                    normalize={(e) => (e ? e.family : null)}
                  />

                  <Field 
                    name='website[feed_style][container][color]'
                    label='Font Color'
                    component={ColorField}
                    hex
                  />
                </Panel.Body>
              </Panel>

               <Panel eventKey="2">
                <Panel.Heading>
                  <Panel.Title toggle>Result Item</Panel.Title>
                </Panel.Heading>
                <Panel.Body collapsible>
                  <Field 
                    name='website[feed_style][result][borderColor]'
                    label='Border Color'
                    component={ColorField}
                    hex
                  />
                </Panel.Body>
              </Panel>

              <Panel eventKey="3">
                <Panel.Heading>
                  <Panel.Title toggle>Title</Panel.Title>
                </Panel.Heading>
                <Panel.Body collapsible>
                  <Field 
                    name='website[feed_style][title][color]'
                    label='Font Color'
                    component={ColorField}
                    hex
                  />

                  <Field 
                    name='website[feed_style][title][fontSize]'
                    label='Font Size'
                    minValue={0}
                    maxValue={18}
                    unit="px"
                    component={SliderField}
                  />

                  <Field 
                    name='website[feed_style][title][fontWeight]'
                    label='Font Weight'
                    minValue={100}
                    maxValue={900}
                    step={100}
                    unit=""
                    component={SliderField}
                  />
                </Panel.Body>
              </Panel>

              <Panel eventKey="4">
                <Panel.Heading>
                  <Panel.Title toggle>Datetime</Panel.Title>
                </Panel.Heading>
                <Panel.Body collapsible>
                  <Field 
                    name='website[feed_style][datetime][color]'
                    label='Font Color'
                    component={ColorField}
                    hex
                  />

                  <Field 
                    name='website[feed_style][datetime][fontSize]'
                    label='Font Size'
                    minValue={0}
                    maxValue={18}
                    unit="px"
                    component={SliderField}
                  />

                  <Field 
                    name='website[feed_style][datetime][fontWeight]'
                    label='Font Weight'
                    minValue={100}
                    maxValue={900}
                    step={100}
                    unit=""
                    component={SliderField}
                  />
                </Panel.Body>
              </Panel>

              <Panel eventKey="5">
                <Panel.Heading>
                  <Panel.Title toggle>Company / Location</Panel.Title>
                </Panel.Heading>
                <Panel.Body collapsible>
                  <Field 
                    name='website[feed_style][subTitle][color]'
                    label='Font Color'
                    component={ColorField}
                    hex
                  />

                  <Field 
                    name='website[feed_style][subTitle][fontSize]'
                    label='Font Size'
                    minValue={0}
                    maxValue={18}
                    unit="px"
                    component={SliderField}
                  />

                  <Field 
                    name='website[feed_style][subTitle][fontWeight]'
                    label='Font Weight'
                    minValue={100}
                    maxValue={900}
                    step={100}
                    unit=""
                    component={SliderField}
                  />
                </Panel.Body>
              </Panel>

              <Panel eventKey="6">
                <Panel.Heading>
                  <Panel.Title toggle>Description</Panel.Title>
                </Panel.Heading>
                <Panel.Body collapsible>
                  <Field 
                    name='website[feed_style][description][color]'
                    label='Font Color'
                    component={ColorField}
                    hex
                  />

                  <Field 
                    name='website[feed_style][description][fontSize]'
                    label='Font Size'
                    minValue={0}
                    maxValue={18}
                    unit="px"
                    component={SliderField}
                  />

                  <Field 
                    name='website[feed_style][description][fontWeight]'
                    label='Font Weight'
                    minValue={100}
                    maxValue={900}
                    step={100}
                    unit=""
                    component={SliderField}
                  />
                </Panel.Body>
              </Panel>

              <Panel eventKey="7">
                <Panel.Heading>
                  <Panel.Title toggle>Filter Header</Panel.Title>
                </Panel.Heading>
                <Panel.Body collapsible>
                  <Field 
                    name='website[feed_style][filter][header][color]'
                    label='Font Color'
                    component={ColorField}
                    hex
                  />

                  <Field 
                    name='website[feed_style][filter][header][fontSize]'
                    label='Font Size'
                    minValue={0}
                    maxValue={18}
                    unit="px"
                    component={SliderField}
                  />

                  <Field 
                    name='website[feed_style][filter][header][fontWeight]'
                    label='Font Weight'
                    minValue={100}
                    maxValue={900}
                    step={100}
                    unit=""
                    component={SliderField}
                  />

                </Panel.Body>
              </Panel>

               <Panel eventKey="8">
                <Panel.Heading>
                  <Panel.Title toggle>Filter Body</Panel.Title>
                </Panel.Heading>
                <Panel.Body collapsible>
                  <Field 
                    name='website[feed_style][filter][body][color]'
                    label='Font Color'
                    component={ColorField}
                    hex
                  />

                  <Field 
                    name='website[feed_style][filter][body][fontSize]'
                    label='Font Size'
                    minValue={0}
                    maxValue={18}
                    unit="px"
                    component={SliderField}
                  />

                  <Field 
                    name='website[feed_style][filter][body][fontWeight]'
                    label='Font Weight'
                    minValue={100}
                    maxValue={900}
                    step={100}
                    unit=""
                    component={SliderField}
                  />

                </Panel.Body>
              </Panel>


               <Panel eventKey="9">
                <Panel.Heading>
                  <Panel.Title toggle>Filter Item</Panel.Title>
                </Panel.Heading>
                <Panel.Body collapsible>
                  <Field 
                    name='website[feed_style][filter][container][borderColor]'
                    label='Border Color'
                    component={ColorField}
                    hex
                  />

                </Panel.Body>
              </Panel>

            </PanelGroup>  
          </div>
        </div>
        
        <br />
        <h5 style={{ fontSize: 14, fontWeight: 700 }}>Filter & Slot Settings</h5>

        <div className="row">
          <div className="col-md-4 col-lg-3">
            <div className='ibox'>
              <div 
                className='ibox-content' 
                style={get(selectedOptions, 'feed_style.filter', {})}
              >
                <FilterList 
                  items={this.state.filters}
                  styles={get(selectedOptions, 'feed_style.filter', {})} 
                  onSortEnd={this.onFilterSortEnd.bind(this)}
                  useDragHandle 
                />
              </div>
            </div>
          </div>
          <div className="col-md-8 col-lg-9">
            <div className='ibox'>
              <div 
                className='ibox-content' 
                style={get(selectedOptions, 'feed_style.container', {})}
              >
                <ResultList 
                  items={this.state.slots} 
                  styles={selectedOptions.feed_style} 
                  onSortEnd={this.onSortEnd.bind(this)}
                  useDragHandle  
                />
              </div>
            </div>
          </div>
        </div>

        <br /><br />
        
        <div className='text-right'>
          <Button
            type='submit'
            loading={isLoading}
            bsStyle='primary'
          >
            Save Changes
          </Button>
        </div>

        <br /><br />
      </form>
    );
  }
}

const ResourceForm = reduxForm({
  form: 'FeedSettingsForm'
});

const mapStateToProps = (state, ownProps) => {
  const { loader } = state;
  const isLoading = loader.includes('FeedSettingsForm');
  const website = get(ownProps, 'website', {});
  const websites = get(state, 'ssp.websites.data', {});
  const adSlots = get(state, 'ssp.adSlots.data', {});
  const selectedOptions = get(state.form, 'FeedSettingsForm.values.website', {});

  const initialValues = {
    website: {
      feed_min_cpc: website.feed_min_cpc,
      feed_jobs_per_page: website.feed_jobs_per_page,
      feed_category: website.feed_category,
      feed_sub_category: website.feed_sub_category || [],
      feed_style: website.feed_style || {}
    }
  };

  return { isLoading, initialValues, websites, selectedOptions, adSlots };
};

export default connect(mapStateToProps)(ResourceForm(Feed));
